'use client';

import { c as _c } from "react/compiler-runtime";
import { SlidingNumber } from './sliding-number';
type ClockProps = {
  hours: number;
  minutes: number;
  seconds?: number;
  showSeconds?: boolean;
  padStart?: boolean;
  separator?: string;
  className?: string;
};
export function Clock(t0) {
  const $ = _c(21);
  const {
    hours,
    minutes,
    seconds,
    showSeconds: t1,
    padStart: t2,
    separator: t3,
    className
  } = t0;
  const showSeconds = t1 === undefined ? true : t1;
  const padStart = t2 === undefined ? true : t2;
  const separator = t3 === undefined ? ":" : t3;
  const safeHours = Math.max(0, Math.floor(hours));
  const safeMinutes = Math.max(0, Math.floor(minutes));
  const safeSeconds = Math.max(0, Math.floor(seconds ?? 0));
  const t4 = `flex items-center gap-0.5 font-mono tabular-nums ${className ?? ""}`;
  let t5;
  if ($[0] !== t4) {
    t5 = t4.trim();
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== padStart || $[3] !== safeHours) {
    t6 = <SlidingNumber value={safeHours} padStart={padStart} />;
    $[2] = padStart;
    $[3] = safeHours;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== separator) {
    t7 = <span className="opacity-70">{separator}</span>;
    $[5] = separator;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== padStart || $[8] !== safeMinutes) {
    t8 = <SlidingNumber value={safeMinutes} padStart={padStart} />;
    $[7] = padStart;
    $[8] = safeMinutes;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== padStart || $[11] !== safeSeconds || $[12] !== separator || $[13] !== showSeconds) {
    t9 = showSeconds && <><span className="opacity-70">{separator}</span><SlidingNumber value={safeSeconds} padStart={padStart} /></>;
    $[10] = padStart;
    $[11] = safeSeconds;
    $[12] = separator;
    $[13] = showSeconds;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t10 = <div className={t5}>{t6}{t7}{t8}{t9}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}